// extracted by mini-css-extract-plugin
module.exports = {"coin":"formatter_coin__TgNbc","base":"formatter_base__IU_E9","termsValue":"formatter_termsValue__jYuft"};